import { useGetHistorialTipoBimlink } from 'lib/react-query/queriesTipoBimLinkProyectos'
import React, { useState } from 'react'
import HistoricalCollapseIcon from './HistoricalCollapseIcon'
import HistoricalTipoBimLinkContent from './HistoricalTipoBimLinkContent'
import Loader from 'components/Spinner/Loader'

const HistoricalTipoBimlink = ({ name }) => {
  const [showData, setShowData] = useState(false)
  const { data, isLoading } = useGetHistorialTipoBimlink(name)

  return (
    <div className="historical-tipo-bimlink-container">
      <div
        className="historical-tipo-bimlink-title-container"
        onClick={() => setShowData(prevState => !prevState)}
      >
        <HistoricalCollapseIcon isOpen={showData} />
        <p className="historical-tipo-bimlink-title">Histórico</p>
      </div>
      <div
        style={{
          height: showData ? 'max-content' : '0px',
        }}
        className="historical-tipo-bimlink-projects-container"
      >
        <div className="historical-tipo-bimlink-projects">
          {isLoading ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '.5rem',
              }}
            >
              <Loader size="30" />
            </div>
          ) : (
            <HistoricalTipoBimLinkContent data={data} />
          )}
        </div>
      </div>
    </div>
  )
}

export default HistoricalTipoBimlink
